import React from 'react'

interface ProgressBarProps {
	stepsLength: number
	currentStep: number
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
	stepsLength,
	currentStep,
}) => {
	const progressBarWidth =
		stepsLength > 0
			? ((currentStep / (stepsLength - 1)) * 100).toString() + '%'
			: '0%'

	return (
		<div className="h-2.5 w-full rounded-full bg-gray-300 dark:bg-gray-700">
			<div
				className="h-2.5 rounded-full bg-primary-400 transition-all duration-300 ease-in-out"
				style={{ width: progressBarWidth }}
			/>
		</div>
	)
}
